module.exports = __webpack_public_path__ + "static/media/1.2ef721f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/soligorsk/1.jpg
// module id = 540
// module chunks = 0